module.exports = __webpack_public_path__ + "img/download.263c8955.png";